<h2 mat-dialog-title>{{ 'QUERY_INSERT_FIELD' | transloco }}</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="field-form">
    <div class="field-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'QUERY_TEMPLATE_TYPE' | transloco }}</mat-label>
        <mat-select formControlName="type">
          <mat-option value="text">text</mat-option>
          <mat-option value="number">number</mat-option>
          <mat-option value="textlist">textlist</mat-option>
          <mat-option value="numberlist">numberlist</mat-option>
          <mat-option value="date">date</mat-option>
          <mat-option value="link">link</mat-option>
        </mat-select>
      </mat-form-field>
      <button
        mat-icon-button
        type="button"
        class="help-button"
        [matTooltip]="tooltips.type"
        matTooltipClass="help-tooltip"
        matTooltipPosition="right"
      >
        <mat-icon>help_outline</mat-icon>
      </button>
    </div>

    @if (isLink) {
      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'QUERY_LINK_URL' | transloco }}</mat-label>
          <input matInput formControlName="url" />
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          class="help-button"
          [matTooltip]="tooltips.url"
          matTooltipClass="help-tooltip"
          matTooltipPosition="right"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'QUERY_LINK_LABEL' | transloco }}</mat-label>
          <input matInput formControlName="label" />
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          class="help-button"
          [matTooltip]="tooltips.linkLabel"
          matTooltipClass="help-tooltip"
          matTooltipPosition="right"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
    } @else {
      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'QUERY_TEMPLATE_NAME' | transloco }}</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          class="help-button"
          [matTooltip]="tooltips.name"
          matTooltipClass="help-tooltip"
          matTooltipPosition="right"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'QUERY_TEMPLATE_LABEL' | transloco }}</mat-label>
          <input matInput formControlName="label" />
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          class="help-button"
          [matTooltip]="tooltips.fieldLabel"
          matTooltipClass="help-tooltip"
          matTooltipPosition="right"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'QUERY_TEMPLATE_DEFAULT' | transloco }}</mat-label>
          <input matInput formControlName="default" />
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          class="help-button"
          [matTooltip]="tooltips.default"
          matTooltipClass="help-tooltip"
          matTooltipPosition="right"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'QUERY_TEMPLATE_DESCRIPTION' | transloco }}</mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          class="help-button"
          [matTooltip]="tooltips.description"
          matTooltipClass="help-tooltip"
          matTooltipPosition="right"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>

      @if (isText) {
        <div class="field-row">
          <mat-form-field appearance="outline">
            <mat-label>Préfixe</mat-label>
            <input matInput formControlName="prefix" />
          </mat-form-field>
          <button
            mat-icon-button
            type="button"
            class="help-button"
            [matTooltip]="tooltips.prefix"
            matTooltipClass="help-tooltip"
            matTooltipPosition="right"
          >
            <mat-icon>help_outline</mat-icon>
          </button>
        </div>

        <div class="field-row">
          <mat-form-field appearance="outline">
            <mat-label>Suffixe</mat-label>
            <input matInput formControlName="suffix" />
          </mat-form-field>
          <button
            mat-icon-button
            type="button"
            class="help-button"
            [matTooltip]="tooltips.suffix"
            matTooltipClass="help-tooltip"
            matTooltipPosition="right"
          >
            <mat-icon>help_outline</mat-icon>
          </button>
        </div>
      }
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="null">{{ 'CANCEL' | transloco }}</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="confirm()">
    {{ 'QUERY_INSERT_FIELD' | transloco }}
  </button>
</mat-dialog-actions>
